import { Component, input } from '@angular/core';

@Component({
  selector: 'app-icon-plus',
  templateUrl: './icon-plus.component.html',
  styleUrls: ['./icon-plus.component.scss'],
})
export class IconPlusComponent {
  width = input<string>('20px');
  height = input<string>('21px');
  color = input<string>('#fff');
}
